export const classes = {
  optionsWrapper: 'options-wrapper flex justify-center items-start ml-3',
  optionsIcon: 'cursor-pointer text-grey-6',
};
